var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('SelectLighthouse',{on:{"connect":function (lighthouse) {
        _vm.$router.push({ path: ("/lighthouse/" + lighthouse) });
      }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }